export default class DafMark {
    constructor() {
        this.addEvents();
    }

    addEvents() {

        let pageGlobal = 1;
        let filterAjax = {
            page: 1,
            masechet: '',
            masechet_learn: '',
            chapter: '',
            lang: $('.daf_learn__list').attr('data-lang')
        }


        $('.daf_number span').on('click', function (e) {
            e.preventDefault();
            let parent = $(this).parents('.daf_number');
            if (parent.hasClass('active')) {
                parent.removeClass('active');
            } else {
                parent.addClass('active')
            }
        })

        $('.daf_number__item').on('click', function (e) {
            e.preventDefault();
            let parent = $(this).parents('.daf_number');
            parent.removeClass('active');
            parent.find('span').html($(this).text());
            filterAjax.page_numb = $(this).attr('data-id');
            generateLink();
        })

        $('.daf_learn__pagination--right').on('click', '.page-numbers:not(.prev):not(.next)', function (e) {
            e.preventDefault();
            filterAjax.page = $(this).text();
            pageGlobal = $(this).text();
            generateLink();
        })

        $('.daf_learn__pagination--right').on('click', '.next', function (e) {
            e.preventDefault();
            filterAjax.page = parseInt(pageGlobal) + 1;
            pageGlobal = parseInt(pageGlobal) + 1;
            generateLink();
        })

        $('.search__pagination--right').on('click', '.prev', function (e) {
            e.preventDefault();
            filterAjax.page = parseInt(pageGlobal) - 1;
            pageGlobal = parseInt(pageGlobal) - 1;
            generateLink();
        })

        function generateLink(bool) {
            $('.daf_learn__list').html(' ');
            $('.daf_learn__pagination--right').html(' ');
            filterAjax.page = 1;
            filterAjax.masechet = $('.daf_learn').attr('data-masechet');
            filterAjax.masechet_learn = $('.daf_learn').attr('data-masechet-learn');
            filterAjax.chapter = $('.daf_learn').attr('data-chapters');

            if (pageGlobal != 1) {
                filterAjax.page = pageGlobal;
            } else {
                filterAjax.page = 1;
            }

            getAjax();
        }

        function getAjax() {
            $.ajax({
                type: "POST",
                url: myAjax.ajaxurl,
                data: {
                    "action": "get_element_learn",
                    filterAjax
                },
                success: function (result) {
                    let results = JSON.parse(result);
                    if (results && results.items) {
                        $('.daf_learn__list').html('');
                        $('.daf_learn__pagination--right').html(results.pagination);
                        $('.daf_learn__pagination--left i').html(results.total);
                        $('.daf_learn__pagination--left span').html(results.current);
                        $.each(results.items, function (i, e) {
                            $(this).appendTo('.daf_learn__list');
                        })
                    }
                }
            });
        }

        $('.follow-ajax:not(.masechet__follow):not(.beyond__follow)').on('click', function (e) {
            let remove = $(this).hasClass('active') ? 'yes' : 'no';
            if($(this).hasClass('active_follow')){
                remove = 'yes';
            }
            let id_page = $(this).attr("data-id");
            follow(id_page, remove, $(this));
            e.preventDefault();
        })

        $('.masechet-post__follow, .masechet__follow').on('click', function (e) {
            let remove = $(this).hasClass('active_follow') ? 'yes' : 'no';
            let id_page = $(this).attr("data-id");
            follow(id_page, remove, $(this), 'follow_masechet_ajax');
            e.preventDefault();
        })

        $('body').on('click', '.beyond__follow', function (e) {
            let remove = $(this).hasClass('active_follow') ? 'yes' : 'no';
            let id_page = $(this).attr("data-id");
            follow(id_page, remove, $(this), 'follow_beyong_ajax');
            e.preventDefault();
        })


        $('body').on('click', '.follow-daf-cat', function (e) {
            e.preventDefault();
            let remove = $(this).hasClass('active_follow') ? 'yes' : 'no';
            let title = $('#beyond-the-daf__title').text().trim();
            let value = $('.jet-radio-list input[data-label="'+title+'"]').attr('value');
            if(value){
                follow(value, remove, $(this), 'follow_beyong_ajax');
            }
        })


        $('body').on('click', '.follow-single-beyong', function (e) {
            e.preventDefault();
            let remove = $(this).hasClass('active_follow') ? 'yes' : 'no';
            follow($(this).attr('data-id'), remove, $(this), 'follow_beyong_ajax');
        })



        $('body').on('click', '.beyond-follow-all', function (e) {
            e.preventDefault();
            let remove = $(this).hasClass('active_follow') ? 'yes' : 'no';
            followAll(remove, $(this), 'follow_beyong_ajax_all');
        })

        function followAll(remove = false, btn, action) {
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": action,
                    'remove': remove,
                    'lang': $('html').attr('lang') != 'en-US' ? '_he' : ''
                },
                success: function (result) {
                    let value = btn.find('p').html();
                    if(btn.attr('data-unfollow') && result == 'added'){
                        btn.addClass('active').addClass('active_follow');
                        value = btn.attr('data-unfollow');
                    }else if(btn.attr('data-follow') && result != 'added'){
                        btn.removeClass('active').removeClass('active_follow');
                        value = btn.attr('data-follow');
                    }else if (result == 'added') {
                        value = value ? value.replace(/Unfollow/i, 'Follow') : '';
                        value = value ? value.replace(/Follow/i, 'Unfollow') : '';
                        btn.addClass('active').addClass('active_follow');
                    } else {
                        value = value ? value.replace(/Unfollow/i, 'Follow') : '';
                        btn.removeClass('active').removeClass('active_follow');
                    }

                    if(value) {
                        btn.find('p').html(value);
                    }
                }
            });
        }


        jQuery( document ).on( 'jet-filter-content-rendered', function() {
            if($('.follow-daf-cat').length > 0){
                setTimeout(()=>{
                    checkCatBeyong();
                }, 100)
            }
        });


        function checkCatBeyong(){
            let titleCat = $('#beyond-the-daf__title').text().trim();
            let valueCat = $('.jet-radio-list input[data-label="'+titleCat+'"]').attr('value');
            if(valueCat){
                $.ajax({
                    type: "POST",
                    url: myAjax.ajaxurl,
                    data: {
                        "action": 'check_beyong_cat',
                        'id_page': valueCat,
                    },
                    success: function (result) {
                        let value = $('.follow-daf-cat p').html();
                        if(result == 'yes'){
                            value = value ? value.replace(/Unfollow/i, 'Follow') : '';
                            value = value ? value.replace(/Follow/i, 'Unfollow') : '';
                            $('.follow-daf-cat').addClass('active_follow');
                        }else{
                            value = value ? value.replace(/Unfollow/i, 'Follow') : '';
                            $('.follow-daf-cat p').html(value);
                            $('.follow-daf-cat').removeClass('active_follow')
                        }

                        if(value) {
                            $('.follow-daf-cat p').html(value);
                        }
                    }
                });
            }
        }


        if($('.follow-daf-cat').length > 0){
            setTimeout(()=>{
                checkCatBeyong();
            }, 1000)
        }


        $('.post-paginate').on('click', '.user-post__follow', function (e) {
            let remove = $(this).hasClass('active') ? 'yes' : 'no';
            let id_page = $(this).attr("data-id");
            follow(id_page, remove, $(this));
            e.preventDefault();
        })

        function getPushEngageId() {
            return new Promise((resolve, reject) => {
                PushEngage.push(function () {
                    PushEngage.getSubscriberId()
                        .then(function (subscriberId) {
                            resolve(subscriberId);
                        })
                        .catch(function (err) {
                            resolve('');
                        });
                });
            });
        }

        function follow(id, remove = false, btn, action = 'follow_ajax') {
            getPushEngageId().then(profilePush => {
                var ajaxurl = myAjax.ajaxurl;
                $.ajax({
                    type: "POST",
                    url: ajaxurl,
                    data: {
                        "action": action,
                        'id_page': id,
                        'remove': remove,
                        'profile_id': profilePush,
                        'author_page': btn.hasClass('author-page') || btn.hasClass('user-post__follow') ? 'yes' : 'no',
                        'lang': $('html').attr('lang') != 'en-US' ? '_he' : ''
                    },
                    success: function (result) {
                        let value = $('.follow-daf-cat p').html() ?? btn.find('p:first-child').html();

                        if(!$('.follow-daf-cat p').html() && btn.find('p:first-child').html() && btn.attr('data-follow')) {
                            if (btn.attr('data-unfollow') && result == 'added') {
                                btn.addClass('active').addClass('active_follow');
                                value = btn.attr('data-unfollow');
                            } else if (btn.attr('data-follow') && result != 'added') {
                                btn.removeClass('active').removeClass('active_follow');
                                value = btn.attr('data-follow');
                            }
                        }else {
                            if (result == 'added') {
                                value = value ? value.replace(/Unfollow/i, 'Follow').replace(/Unsubscribe/i, 'Subscribe') : '';
                                value = value ? value.replace(/Follow/i, 'Unfollow').replace(/Subscribe/i, 'Unsubscribe').replace(/Notifications off/i, 'Notifications on') : '';
                                btn.addClass('active').addClass('active_follow');
                            } else {
                                value = value ? value.replace(/Unfollow/i, 'Follow').replace(/Unsubscribe/i, 'Subscribe').replace(/Notifications on/i, 'Notifications off') : '';
                                btn.removeClass('active').removeClass('active_follow');
                            }
                        }

                        if(value){
                            $('.follow-daf-cat p').html(value);
                            $('.daf_sefaria__follow span').html(value);
                            if(result == 'added'){
                                $('.daf_sefaria__follow').addClass('active').addClass('active_follow');
                            }else{
                                $('.daf_sefaria__follow').removeClass('active').removeClass('active_follow');
                            }
                            btn.find('p:first-child').html(value);
                        }
                    }
                });
            });
        }


        $('.follow-author a').on('click', function (e) {
            let id_page = $(this).find('.user_follow-id .jet-listing-dynamic-field__content').text();
            e.preventDefault();
            follow(id_page, '', $(this));
        })


        $('.daf_sefaria__follow').on('click', function (e) {
            e.preventDefault();
            let btn = $(this);
            $.ajax({
                type: "POST",
                url: myAjax.ajaxurl,
                data: {
                    "action": "follow_ajax",
                    'id_page': $(this).attr('data-id'),
                    'remove' : $(this).hasClass('active_follow') ? 'yes' : 'no',
                    'author_page' : 'no',
                    'lang': $('html').attr('lang') != 'en-US' ? 'he' : ''
                },
                success: function (result) {
                    let value = $('.daf_sefaria__follow span').html();
                    if(btn.attr('data-unfollow') && result == 'added'){
                        $(this).addClass('active').addClass('active_follow');
                        value = btn.attr('data-unfollow');
                    }else if(btn.attr('data-follow') && result == 'removed'){
                        $(this).removeClass('active').removeClass('active_follow');
                        value = btn.attr('data-follow');
                    }else if (result == 'added') {
                        value = value ? value.replace(/Unfollow/i, 'Follow').replace(/Unsubscribe/i, 'Subscribe') : '';
                        value = value ? value.replace(/Follow/i, 'Unfollow').replace(/Subscribe/i, 'Unsubscribe') : '';
                        $(this).addClass('active').addClass('active_follow');
                    } else {
                        value = value ? value.replace(/Unfollow/i, 'Follow').replace(/Unsubscribe/i, 'Subscribe') : '';
                        $(this).removeClass('active').removeClass('active_follow');
                    }

                    if(value){
                        $('.follow-ajax p, .daf_sefaria__follow span').html(value);
                        if(result == 'added'){
                            $('.follow-ajax, .daf_sefaria__follow').addClass('active').addClass('active_follow');
                        }else{
                            $('.follow-ajax, .daf_sefaria__follow').removeClass('active').removeClass('active_follow');
                        }
                    }
                }
            });
        })


        $('.daf-mark-complete').on('click', function (e) {
            let params = new URL(window.location.href).searchParams;
            let remove = $(this).hasClass('completed') ? 'yes' : 'no';
            let id_page = $(this).attr("data-id");
            let navigation_url = $(this).data('navigation');
            let masechet = params.get('masechet') ?? '';
            masechet = masechet ? masechet : $(this).data('masechet');

            e.preventDefault();
            $.ajax({
                type: "POST",
                url: myAjax.ajaxurl,
                data: {
                    "action": "mark_as_complete_ajax",
                    'id_page': id_page,
                    'remove': masechet ? 'no' : remove,
                    'masechet': masechet
                },
                success: function (result) {
                    let parent = $('.daf-mark-complete[data-id="' + id_page + '"]');

                    if (result != 0) {
                        if (navigation_url) {
                            window.location.href = navigation_url;
                        }
                        parent.addClass('completed');
                        parent.find('span').html('Completed');
                    } else {
                        parent.removeClass('completed');
                        parent.find('span').html('Mark as complete');
                    }
                    if (masechet) {
                        window.location.reload();
                    }
                }
            });
        })

        $('.beyong-mark-complete').on('click', function (e) {
            let btn = $(this);
            let remove = $(this).hasClass('completed') ? 'yes' : 'no';
            let id_page = $(this).attr("data-id");

            e.preventDefault();
            $.ajax({
                type: "POST",
                url: myAjax.ajaxurl,
                data: {
                    "action": "mark_as_complete_ajax",
                    'id_page': id_page,
                    'remove': remove,
                },
                success: function (result) {
                    if (result != 0) {
                        btn.addClass('completed');
                        btn.find('p').html('Completed');
                    } else {
                        btn.removeClass('completed');
                        btn.find('p').html('Mark as complete');
                    }
                }
            });
        })
    }
}